package fr.arcplex.network.http

import io.ktor.client.HttpClient
import io.ktor.client.HttpClientConfig

/**
 * Web targets cannot bypass certificate validation: TLS is owned by the browser,
 * so [allowInvalidCertificates] is intentionally ignored here.
 */
actual fun createNetworkHttpClient(
    allowInvalidCertificates: Boolean,
    configure: HttpClientConfig<*>.() -> Unit
): HttpClient = HttpClient {
    configure()
}
